export class Rotate {
    public angle: number;

    constructor(angle: number) {
        this.angle = angle;
    }
}
